// dependencies
import React from 'react';
import './Footer.css';
import { RiHeartsLine } from 'react-icons/ri';

const Footer = () => {
   return (
      <div className="footer text-center">
         <p className="common-blue footer-text">
            {' '}
            Made with <RiHeartsLine /> by{' '}
            <a
               className="common-blue underlined text"
               style={{
                  fontSize: '16px',
                  fontFamily: 'Oswald',
                  color: '#1c8de5',
               }}
               href="https://facebook.com/mehediislamripon/"
               target="_blank"
               rel="noreferrer"
            >
               {' '}
               Mehedi Islam Ripon{' '}
            </a>{' '}
         </p>
      </div>
   );
};

export default Footer;
